import { render, staticRenderFns } from "./UnregisteredStationsBubble.vue?vue&type=template&id=0b1e3b5a&"
import script from "./UnregisteredStationsBubble.vue?vue&type=script&lang=ts&"
export * from "./UnregisteredStationsBubble.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports